var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.65 18H.35c-.194 0-.35-.154-.35-.344 0-3.205 1.744-6.182 4.552-7.77.167-.094.38-.038.476.126.097.165.04.374-.128.47C2.409 11.89.825 14.485.706 17.313h16.589c-.16-3.858-2.984-7.1-6.834-7.78l-.136-.015c-.174 0-.32-.125-.346-.294-.025-.169.08-.33.246-.378 1.803-.534 3.014-2.137 3.014-3.99 0-2.299-1.902-4.169-4.24-4.169-2.336 0-4.237 1.87-4.237 4.17 0 1.825 1.24 3.466 3.015 3.992.184.055.289.246.233.428-.055.182-.25.285-.435.23-2.068-.612-3.512-2.524-3.512-4.65C4.063 2.178 6.278 0 9 0c2.722 0 4.937 2.179 4.937 4.856 0 1.776-.955 3.354-2.463 4.204C15.306 10.14 18 13.622 18 17.656c0 .19-.156.344-.35.344z",
    transform: "translate(6 6) translate(3 3)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z",
    transform: "translate(6 6)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserActive);
export default __webpack_public_path__ + "static/media/user-active.99a00c65b1e218fff1c6aa783c0690b2.svg";
export { ForwardRef as ReactComponent };